import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("isAuthenticated") === "true"
  );

  const authenticateUser = (status) => {
    setIsAuthenticated(status);
    sessionStorage.setItem("isAuthenticated", status);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authenticateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
